import { useQueryGetDelivery, useQueryGetDeliveryTimeline } from '../deliveries-details.queries';
import { useCallback, useMemo, useState } from 'react';
import { DeliveryDetailsActions } from '../actions/deliveries-details.actions';

interface DeliveryDetailsPageState {
  currentAction: DeliveryDetailsActions | null;
}

const initialState: DeliveryDetailsPageState = {
  currentAction: null
};

export function useDeliveryDetails(deliveryID: string) {
  const [state, setState] = useState(initialState);

  const delivery = useQueryGetDelivery(deliveryID);
  const timeline = useQueryGetDeliveryTimeline(deliveryID);

  function setAction(action: DeliveryDetailsActions | null) {
    setState((state) => ({ ...state, currentAction: action }));
  }

  const endAction = useCallback((nextAction?: DeliveryDetailsActions) => {
    setAction(nextAction || null);
  }, []);

  const handlers = useMemo(
    () => ({
      setAction,
      endAction
    }),
    [endAction]
  );

  return { delivery, timeline, state, handlers } as const;
}
